<style lang="scss"></style>

<template>
  <div id="modal-remove-tipo-produto" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="tipoProduto">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o tipo de produto
                    <span
                      class="text-info"
                    >{{ tipoProduto.nome }}</span>?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../../helpers';
import TipoProdutoService from '../../../services/TipoProdutoService';

export default {
  name: 'modal-remove-tipo-produto',
  data() {
    return {
      enviando: false,
      tipoProduto: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-tipo-produto').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeTipoProdutoId = null;
    });

    if (this.$parent.removeTipoProdutoId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.tipoProduto = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeTipoProdutoId === 0) return;

        this.tipoProduto = await TipoProdutoService.findById(
          this.$parent.removeTipoProdutoId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-tipo-produto').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await TipoProdutoService.remove(this.tipoProduto.id);

        this.$toast.success('Tipo de produto removido com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-tipo-produto').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
